import styled, { css } from 'styled-components';
import { WhiteCardHeader } from '../NewHomeLayoutHandler/NewHomeLayoutHandler.styles';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    position: relative;
  `}
`;

export const CardsWrapper = styled.div`
  ${({ theme }) => css`
    display: grid;
    gap: ${theme.v3.spacing.xxs} ${theme.v3.spacing.xxxs};
    grid-template-columns: 628fr 620fr;
    grid-template-rows: 1fr 1fr;
    margin-left: auto;
    margin-right: auto;
    max-width: 1264px;
    width: 100%;

    @media (max-width: ${theme.v3.breakpoints.lg}) {
      grid-template-columns: 1fr 1fr;
      max-width: none;
    }

    @media (max-width: ${theme.v3.breakpoints.md}) {
      gap: 0;
      grid-auto-rows: auto;
      grid-template-columns: repeat(1, 1fr);
      grid-template-rows: none;
      margin-left: -${theme.v3.spacing.xxs};
      margin-right: -${theme.v3.spacing.xxs};
      width: auto;
    }
  `}
`;

export const Header = styled(WhiteCardHeader)`
  margin-left: auto;
  margin-right: auto;
  max-width: 1264px;
  width: 100%;
`;

export const Card = styled.button`
  ${({ theme, $featured, $variant }) => {
    const isGatorProtectCard = $variant === 'gator-protect';
    const isHostingCard = $variant === 'hosting';
    const isOpenClawCard = $variant === 'open-claw';
    const isEmailCard = $variant === 'email';
    let background = theme.v3.colors.neutral[100];
    const minHeight = $featured ? '496px' : '236px';
    const overflow = isEmailCard ? 'visible' : 'hidden';
    let mobileMinHeight = '320px';

    if ($featured) {
      mobileMinHeight = '360px';
    }

    if ($featured && isGatorProtectCard) {
      mobileMinHeight = '360px';
    }

    if (isOpenClawCard) {
      mobileMinHeight = '360px';
    }

    if (isEmailCard) {
      mobileMinHeight = '360px';
    }

    if (isGatorProtectCard) {
      background = `linear-gradient(180deg, ${theme.v3.colors.neutral[100]} 0%, ${theme.v3.colors.accent.green[98]} 100%)`;
    }

    if (isHostingCard) {
      background = `linear-gradient(180deg, ${theme.v3.colors.neutral[100]} 0%, ${theme.v3.colors.neutral[100]} 58%, rgba(235, 255, 229, 0.42) 100%)`;
    }

    if (isEmailCard) {
      background = `linear-gradient(180deg, ${theme.v3.colors.neutral[100]} 0%, ${theme.v3.colors.accent.pink[98]} 100%)`;
    }

    return css`
      appearance: none;
      background: ${background};
      border: 1px solid ${theme.v3.colors.brand.snappyBlue[95]};
      border-radius: ${theme.v3.border.radius.round};
      box-shadow: 0 5px 10px 0 rgba(223, 226, 235, 0.24), 0 4px 8px 0 rgba(223, 226, 235, 0.18);
      cursor: pointer;
      font-family: ${theme.v3.font.family.brand};
      height: 100%;
      min-height: ${minHeight};
      overflow: ${overflow};
      padding: 0;
      position: relative;
      text-align: left;
      transition: transform 0.3s ease, box-shadow 0.3s ease;
      width: 100%;

      :hover {
        box-shadow: 0 8px 16px 0 rgba(223, 226, 235, 0.32), 0 6px 12px 0 rgba(223, 226, 235, 0.24);
        transform: translateY(-5px);
      }

      :focus-visible {
        outline: 2px solid ${theme.v3.colors.brand.snappyBlue[50]};
        outline-offset: 2px;
      }

      @media (max-width: ${theme.v3.breakpoints.md}) {
        border: 0;
        border-radius: 0;
        box-shadow: none;
        grid-row: auto;
        height: auto;
        min-height: ${mobileMinHeight};

        :hover {
          box-shadow: none;
          transform: none;
        }
      }
    `;
  }}
`;

export const CardContent = styled.div`
  ${({ theme, $featured, $variant }) => {
    const isHostingCard = $variant === 'hosting';
    const isOpenClawCard = $variant === 'open-claw';
    const isGatorProtectFeatured = $featured && $variant === 'gator-protect';
    const isEmailCard = $variant === 'email';
    let contentGap = theme.v3.spacing.nano;
    let contentPadding = `${theme.v3.spacing.xs} ${theme.v3.spacing.xxs} ${theme.v3.spacing.xxs}`;
    let contentPaddingFallback = contentPadding;
    let mobileGap = theme.v3.spacing.xxs;
    let mobilePadding = `${theme.v3.spacing.xs} ${theme.v3.spacing.xxs} ${theme.v3.spacing.xxs}`;

    if ($featured) {
      contentGap = theme.v3.spacing.xxs;
      contentPadding = `${theme.v3.spacing.sm} ${theme.v3.spacing.sm} 30px`;
      contentPaddingFallback = contentPadding;
      mobileGap = '20px';
      mobilePadding = `${theme.v3.spacing.xs} ${theme.v3.spacing.xxs} ${theme.v3.spacing.xxs}`;
    }

    if (isHostingCard) {
      contentGap = '20px';
      contentPaddingFallback = `${theme.v3.spacing.md} 96px 30px`;
      contentPadding = 'clamp(32px, 7.6cqw, 48px) clamp(32px, 15.3cqw, 96px) 30px';
      mobilePadding = `${theme.v3.spacing.xs} ${theme.v3.spacing.xxs} 18px`;
    }

    if (isOpenClawCard) {
      contentGap = '0';
      contentPadding = `${theme.v3.spacing.xxs} ${theme.v3.spacing.xs} ${theme.v3.spacing.xxs} ${theme.v3.spacing.xxs}`;
      contentPaddingFallback = contentPadding;
      mobileGap = theme.v3.spacing.xxxs;
      mobilePadding = `${theme.v3.spacing.md} ${theme.v3.spacing.xxs} 0`;
    }

    if (isGatorProtectFeatured) {
      contentGap = theme.v3.spacing.xxs;
      contentPadding = `0 ${theme.v3.spacing.xs} ${theme.v3.spacing.xxl} ${theme.v3.spacing.xs}`;
      contentPaddingFallback = contentPadding;
      mobileGap = '25px';
      mobilePadding = `${theme.v3.spacing.xs} ${theme.v3.spacing.xxs} 0`;
    }

    if (isEmailCard) {
      mobileGap = '24px';
      mobilePadding = `${theme.v3.spacing.xl} ${theme.v3.spacing.xxs} 0`;
    }

    const flexDirection = $featured ? 'column' : 'row';
    const alignItems = $featured ? 'flex-start' : 'center';
    const narrowPadding = isOpenClawCard
      ? `${theme.v3.spacing.xxs} ${theme.v3.spacing.xxs}`
      : contentPadding;

    return css`
      align-items: ${alignItems};
      display: flex;
      flex-direction: ${flexDirection};
      gap: ${contentGap};
      height: ${isGatorProtectFeatured ? '496px' : '100%'};
      justify-content: space-between;
      min-height: inherit;
      padding: ${contentPaddingFallback};
      padding: ${contentPadding};
      position: relative;

      @container (max-width: 560px) {
        padding: ${narrowPadding};
      }

      @media (max-width: ${theme.v3.breakpoints.md}) {
        align-items: center;
        flex-direction: column;
        gap: ${mobileGap};
        height: ${isGatorProtectFeatured ? 'auto' : '100%'};
        justify-content: flex-start;
        padding: ${mobilePadding};
        text-align: center;
      }
    `;
  }}
`;

export const CardTextGroup = styled.div`
  ${({ theme, $featured, $variant }) => {
    const isGatorProtectFeatured = $featured && $variant === 'gator-protect';

    if (isGatorProtectFeatured) {
      return css`
        left: ${theme.v3.spacing.xs};
        position: absolute;
        right: ${theme.v3.spacing.xs};
        top: 202px;
        z-index: 2;

        @media (max-width: ${theme.v3.breakpoints.md}) {
          align-items: center;
          display: flex;
          flex-direction: column;
          left: auto;
          position: relative;
          right: auto;
          text-align: center;
          top: auto;
          width: 100%;
        }
      `;
    }

    return css`
      flex: 1 1 auto;
      min-width: 0;
      position: relative;
      z-index: 2;

      @media (max-width: ${theme.v3.breakpoints.md}) {
        align-items: center;
        display: flex;
        flex-direction: column;
        text-align: center;
        width: 100%;
      }
    `;
  }}
`;

export const CardTitle = styled.h3`
  ${({ theme, $featured, $variant }) => {
    const isHostingCard = $variant === 'hosting';
    const isOpenClawCard = $variant === 'open-claw';
    const isEmailCard = $variant === 'email';
    const isGatorProtectFeatured = $featured && $variant === 'gator-protect';
    let fontSize = $featured ? theme.v3.font.sizes['2xlarge'] : theme.v3.font.sizes.large;
    let fontSizeFallback = fontSize;
    let titleMaxWidth = '330px';
    let titleMaxWidthFallback = titleMaxWidth;

    if ($featured) {
      titleMaxWidth = '440px';
      titleMaxWidthFallback = titleMaxWidth;
    }

    if (isGatorProtectFeatured) {
      titleMaxWidth = '375px';
      titleMaxWidthFallback = titleMaxWidth;
    }

    if (isHostingCard) {
      fontSizeFallback = theme.v3.font.sizes['2xlarge'];
      fontSize = 'clamp(20px, 4.5cqw, 28px)';
      titleMaxWidthFallback = '390px';
      titleMaxWidth = 'clamp(320px, 62cqw, 390px)';
    }

    if (isOpenClawCard) {
      fontSizeFallback = theme.v3.font.sizes['1xlarge'];
      fontSize = 'clamp(18px, 3.9cqw, 23px)';
      titleMaxWidthFallback = '341px';
      titleMaxWidth = '341px';
    }

    if (isEmailCard) {
      fontSizeFallback = theme.v3.font.sizes['1xlarge'];
      fontSize = 'clamp(18px, 4.2cqw, 24px)';
      titleMaxWidthFallback = '320px';
      titleMaxWidth = 'clamp(220px, 55cqw, 320px)';
    }

    let mobileFontSize = 'clamp(22px, 6vw, 28px)';
    let mobileFontWeight = theme.v3.font.weights.medium;
    let mobileLineHeight = theme.v3.font.lineHeight.relaxed;
    let mobileTitleMaxWidth = '330px';

    if ($featured) {
      mobileFontSize = 'clamp(22px, 7.2vw, 32px)';
      mobileTitleMaxWidth = '640px';
    }

    if (isHostingCard) {
      mobileFontSize = theme.v3.font.sizes.large;
      mobileTitleMaxWidth = '100%';
    }

    if (isGatorProtectFeatured) {
      mobileFontSize = theme.v3.font.sizes['1xmedium'];
      mobileFontWeight = theme.v3.font.weights.bold;
      mobileLineHeight = theme.v3.font.lineHeight.comfortable;
      mobileTitleMaxWidth = '310px';
    }

    return css`
      color: ${theme.v3.colors.brand.snappyBlue[15]};
      font-size: ${fontSizeFallback};
      font-size: ${fontSize};
      font-weight: ${theme.v3.font.weights.medium};
      line-height: ${theme.v3.font.lineHeight.relaxed};
      margin: 0;
      max-width: ${titleMaxWidthFallback};
      max-width: ${titleMaxWidth};
      white-space: ${isOpenClawCard ? 'pre' : 'normal'};

      @media (max-width: ${theme.v3.breakpoints.md}) {
        font-size: ${mobileFontSize};
        font-weight: ${mobileFontWeight};
        line-height: ${mobileLineHeight};
        max-width: ${mobileTitleMaxWidth};
        text-align: center;
        white-space: normal;
      }
    `;
  }}
`;

export const CardTitleHighlight = styled.span`
  background: linear-gradient(90deg, #2E93EE 0%, #2E93EE 6.25%, #2F92ED 12.5%, #3091ED 18.75%, #3190EC 25%, #338EEB 31.25%, #358CE9 37.5%, #3789E8 43.75%, #3A86E6 50%, #3D83E4 56.25%, #417FE1 62.5%, #457BDF 68.75%, #4976DC 75%, #4E71D9 81.25%, #536CD5 87.5%, #5866D2 93.75%, #5E60CE 100%);
  background-clip: text;
  font-weight: ${({ theme }) => theme.v3.font.weights.bold};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const CardCta = styled.span`
  ${({ theme, $featured, $variant }) => {
    const isFeaturedHostingCard = $featured && $variant === 'hosting';
    const isOpenClawCard = $variant === 'open-claw';
    const isEmailCard = $variant === 'email';
    const needsLargerFont = isFeaturedHostingCard || isOpenClawCard || isEmailCard;
    let fontSize = needsLargerFont ? theme.v3.font.sizes['1xmedium'] : theme.v3.font.sizes.medium;
    const fontSizeFallback = fontSize;
    const lineHeight = needsLargerFont ? 'normal' : theme.v3.font.lineHeight.comfortable;
    let marginTop = isOpenClawCard ? theme.v3.spacing.xs : theme.v3.spacing.xxs;
    const marginTopFallback = marginTop;

    if (needsLargerFont) {
      fontSize = 'clamp(14px, 3.5cqw, 18px)';
    }

    if (isOpenClawCard) {
      marginTop = 'clamp(16px, 5.2cqw, 32px)';
    }

    return css`
      align-items: center;
      color: ${theme.v3.colors.neutral[20]};
      display: inline-flex;
      font-size: ${fontSizeFallback};
      font-size: ${fontSize};
      font-weight: ${theme.v3.font.weights.medium};
      gap: ${theme.v3.spacing.nano};
      line-height: ${lineHeight};
      margin-top: ${marginTopFallback};
      margin-top: ${marginTop};

      svg {
        flex-shrink: 0;
      }

      @media (max-width: ${theme.v3.breakpoints.md}) {
        font-size: ${theme.v3.font.sizes.medium};
        gap: ${theme.v3.spacing.nano};
        justify-content: center;
        line-height: ${theme.v3.font.lineHeight.comfortable};
        margin-top: ${theme.v3.spacing.xxxs};

        svg {
          height: 14px;
          width: 18px;
        }
      }
    `;
  }}
`;

export const CardIllustration = styled.div`
  ${({ theme, $featured, $variant }) => {
    const isHostingCard = $variant === 'hosting';
    const isOpenClawCard = $variant === 'open-claw';
    const isGatorProtectFeatured = $featured && $variant === 'gator-protect';
    let alignItems = isHostingCard ? 'flex-start' : 'center';
    let flex = $featured ? '1 1 auto' : '0 0 42%';
    let flexFallback = flex;
    let justifyContent = isHostingCard ? 'flex-start' : 'center';

    if (isOpenClawCard) {
      alignItems = 'flex-end';
      flexFallback = '0 0 229px';
      flex = '0 1 clamp(164px, 37cqw, 229px)';
      justifyContent = 'flex-end';
    }

    return css`
      align-items: ${alignItems};
      align-self: stretch;
      display: flex;
      flex: ${flexFallback};
      flex: ${flex};
      justify-content: ${justifyContent};
      min-width: 0;
      overflow: ${(isOpenClawCard || isGatorProtectFeatured || $variant === 'email') ? 'visible' : 'hidden'};
      position: ${isGatorProtectFeatured ? 'static' : 'relative'};

      @media (max-width: ${theme.v3.breakpoints.md}) {
        align-items: center;
        align-self: center;
        flex: 0 0 auto;
        justify-content: center;
        min-height: ${isGatorProtectFeatured ? '160px' : '0'};
        overflow: visible;
        width: 100%;
      }
    `;
  }}
`;

export const HostingIllustration = styled.img`
  ${({ theme }) => css`
    display: block;
    height: auto;
    margin: 0;
    max-height: 277.067px;
    max-width: 407.65px;
    max-width: clamp(300px, 65cqw, 407.65px);
    object-fit: contain;
    width: 100%;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      max-height: none;
      max-width: 300px;
      width: min(56vw, 300px);
    }
  `}
`;

export const OpenClawIllustration = styled.div`
  flex-shrink: 0;
  height: 220px;
  height: clamp(158px, 35.5cqw, 220px);
  margin: 0 -12px -32px 0;
  margin: 0 clamp(-12px, -1.9cqw, -6px) clamp(-32px, -5.2cqw, -16px) 0;
  position: relative;
  width: 229px;
  width: clamp(164px, 37cqw, 229px);
  z-index: 1;

  ${({ theme }) => css`
    @media (max-width: ${theme.v3.breakpoints.md}) {
      height: auto;
      margin: 0 auto -4px;
      width: min(58vw, 260px);
    }
  `}
`;

export const OpenClawImage = styled.img`
  display: block;
  height: 220px;
  height: clamp(158px, 35.5cqw, 220px);
  position: relative;
  width: 229px;
  width: clamp(164px, 37cqw, 229px);
  z-index: 1;

  ${({ theme }) => css`
    @media (max-width: ${theme.v3.breakpoints.md}) {
      height: auto;
      width: min(58vw, 260px);
    }
  `}
`;

export const OpenClawGlow = styled.div`
  ${({ theme }) => css`
    background: ${theme.v3.colors.brand.snappyBlue[90]};
    border-radius: 369.044px;
    bottom: -91px;
    filter: blur(165px);
    height: 301px;
    pointer-events: none;
    position: absolute;
    right: 104px;
    width: 370px;
    z-index: 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      bottom: -76px;
      left: 50%;
      right: auto;
      transform: translateX(-50%);
      width: min(100vw, 370px);
    }
  `}
`;

export const GatorProtectIllustration = styled.div`
  ${({ theme }) => css`
    flex: 1 1 auto;
    height: 100%;
    position: static;
    width: 100%;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex: 0 0 auto;
      height: 190px;
      position: relative;
      width: 100%;
    }
  `}
`;

export const SecurityMetrics = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 31.3px;
  right: clamp(16px, 5cqw, 31.3px);
  top: 52px;
  top: clamp(36px, 8.2cqw, 52px);
  z-index: 2;

  ${({ theme }) => css`
    @media (max-width: ${theme.v3.breakpoints.md}) {
      bottom: ${theme.v3.spacing.lg};
      position: absolute;
      right: 20.6px;
      top: auto;
    }
  `}
`;

export const SecurityMetric = styled.div`
  ${({ theme }) => css`
    background: rgba(255, 255, 255, 0.90);
    border: 0.91px solid #FFB3AD;
    border-radius: ${theme.v3.border.radius.md};
    box-shadow: 0 3.638px 7.276px 0 rgba(223, 226, 235, 0.22), 0 2.729px 5.457px 0 rgba(223, 226, 235, 0.16);
    min-width: 200px;
    min-width: clamp(150px, 31.8cqw, 200px);
    padding: 8px 14.55px;

    & + & {
      margin-left: 65px;
      margin-top: -30px;
    }

    @media (max-width: ${theme.v3.breakpoints.md}) {
      border: 0.544px solid #FFB3AD;
      box-shadow: 0 2.178px 4.355px 0 rgba(223, 226, 235, 0.22), 0 1.633px 3.266px 0 rgba(223, 226, 235, 0.16);
      padding: 8.71px;
      width: 120px;
      margin-top: -10px;

      & + & {
        margin-left: 37.8px;
        margin-top: 10px;
      }
    }
  `}
`;

export const SecurityMetricLabel = styled.span`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v3.colors.neutral[20]};
    display: flex;
    font-family: ${theme.v3.font.family.brand};
    font-size: 14.553px;
    font-weight: ${theme.v3.font.weights.medium};
    gap: ${theme.v3.spacing.nano};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    white-space: nowrap;

    svg {
      display: block;
      flex-shrink: 0;
      height: 14.553px;
      width: 14.553px;
    }

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: 8.71px;
      gap: 3px;
      line-height: ${theme.v3.font.lineHeight.comfortable};
      white-space: nowrap;

      svg {
        height: 8.71px;
        width: 8.71px;
      }
    }
  `}
`;

export const SecurityMetricValue = styled.strong`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    display: block;
    font-family: ${theme.v3.font.family.brand};
    font-size: 32.743px;
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.relaxed};
    margin-top: 2px;
    padding-left: 22.553px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: 19.598px;
      line-height: ${theme.v3.font.lineHeight.relaxed};
      padding-left: 11.71px;
      text-align: left;
    }
  `}
`;

export const SnappyIllustration = styled.img`
  bottom: 0px;
  display: block;
  height: auto;
  pointer-events: none;
  position: absolute;
  right: 10px;
  width: 234px;
  width: clamp(190px, 37cqw, 234px);
  z-index: 1;

  ${({ theme }) => css`
    @media (max-width: ${theme.v3.breakpoints.md}) {
      bottom: 0;
      left: 0;
      right: auto;
      top: auto;
      width: min(42vw, 200px);
      z-index: 0;
    }
  `}
`;

export const EmailIllustration = styled.div`
  align-items: flex-end;
  display: flex;
  height: 100%;
  justify-content: flex-end;
  position: relative;
  width: 100%;

  ${({ theme }) => css`
    @media (max-width: ${theme.v3.breakpoints.md}) {
      align-items: center;
      justify-content: center;
    }
  `}
`;

export const EmailImageContainer = styled.div`
  align-self: flex-end;
  display: inline-flex;
  position: relative;
`;

export const EmailBannerImage = styled.img`
  display: block;
  height: auto;
  max-height: 160px;
  max-height: clamp(112px, 26cqw, 160px);
  max-width: 100%;
  object-fit: contain;
  object-position: right;

  ${({ theme }) => css`
    @media (max-width: ${theme.v3.breakpoints.md}) {
      max-height: none;
      width: min(64vw, 240px);
    }
  `}
`;

export const EmailAddressChip = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background: ${theme.v3.colors.neutral[100]};
    border-radius: ${theme.v3.border.radius.md};
    bottom: 29.12px;
    box-shadow: 0 8px 20px rgba(31, 32, 68, 0.14);
    display: flex;
    gap: ${theme.v3.spacing.nano};
    left: -24px;
    padding: 10px 14px;
    position: absolute;
    white-space: nowrap;
    z-index: 2;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      bottom: 38px;
      left: -16px;
      padding: 8px 12px;
    }
  `}
`;

export const EmailGlow = styled.div`
  ${({ theme }) => css`
    background: ${theme.v3.colors.accent.pink[90]};
    border-radius: 433.842px;
    bottom: -169px;
    filter: blur(165px);
    height: 433px;
    opacity: 0.7;
    pointer-events: none;
    position: absolute;
    right: 76px;
    transform: rotate(87.36deg);
    width: 276px;
    z-index: 0;
  `}
`;

export const EmailAddressText = styled.span`
  ${({ theme }) => css`
    color: #363636;
    font-family: ${theme.v3.font.family.brand};
    font-size: 13.65px;
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
  `}
`;

export const CardWrapper = styled.div`
  ${({ theme, $featured }) => css`
    container-type: inline-size;
    grid-row: ${$featured ? '1 / -1' : 'auto'};
    min-width: 0;
    position: relative;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      grid-row: auto;
    }
  `}
`;

export const Tag = styled.span`
  ${({ theme }) => css`
    align-items: center;
    background: ${theme.v3.colors.accent.green[70]};
    border-radius: ${theme.v3.border.radius.sm};
    color: ${theme.v3.colors.neutral[100]};
    display: flex;
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.medium};
    height: 24px;
    justify-content: center;
    line-height: ${theme.v3.font.lineHeight.comfortable};
    padding: 0 ${theme.v3.spacing.nano};
    position: absolute;
    right: ${theme.v3.spacing.xxs};
    top: 0;
    transform: translateY(-50%);
    white-space: nowrap;
    z-index: 3;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      right: ${theme.v3.spacing.nano};
      top: ${theme.v3.spacing.xxs};
      transform: none;
    }
  `}
`;
